import React, { useState } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

const NSTSELanding = () => {
  const [classLevel, setClassLevel] = useState("");

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: 20, fontFamily: "'Nunito', sans-serif" }}>
      <SEO
        title="NSTSE Preparation – National Science Talent Search Examination"
        description="Prepare for NSTSE 2026-27 with free AI-powered mock tests for Classes 6 to 10. Full syllabus, 60 questions, 60 minutes, instant scoring and detailed reports."
        canonical="https://eluvent.com/nstse"
      />

      <div style={{ textAlign: "center", marginBottom: 30 }}>
        <h1 style={{ fontSize: 36, fontWeight: 800, color: "#1e3a5f", margin: 0 }}>
          🧪 NSTSE Preparation
        </h1>
        <p style={{ fontSize: 18, color: "#64748b", marginTop: 8 }}>
          National Science Talent Search Examination – Classes 6 to 10.
        </p>
        <p style={{ fontSize: 14, color: "#94a3b8" }}>
          Mock Exam: 17 January 2027 &nbsp;|&nbsp; Final Exam: 24 January 2027
        </p>
      </div>

      {/* Exam Pattern Card */}
      <div style={{ background: "white", borderRadius: 20, padding: 24, marginBottom: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0" }}>
        <h2 style={{ fontSize: 26, fontWeight: 800, color: "#1e293b", margin: "0 0 8px" }}>
          Exam Pattern – Classes 6‑10
        </h2>
        <p style={{ color: "#475569", fontSize: 15, lineHeight: 1.6, marginBottom: 12 }}>
          NSTSE consists of 60 objective questions (60 marks) to be completed in 60 minutes.
        </p>
        <ul style={{ fontSize: 14, color: "#334155", lineHeight: 1.8 }}>
          <li>Mathematics – 10 questions</li>
          <li>Physics – 15 questions</li>
          <li>Chemistry – 15 questions</li>
          <li>Biology – 15 questions</li>
          <li>Critical Thinking – 5 questions</li>
        </ul>
      </div>

      {/* Class Selector */}
      <div style={{ background: "white", borderRadius: 20, padding: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0" }}>
        <h3 style={{ fontSize: 22, fontWeight: 700, color: "#1e293b", marginBottom: 16 }}>
          Start Your Mock Test
        </h3>
        <label style={{ fontWeight: 600, fontSize: 15, display: "block", marginBottom: 8 }}>
          Select Your Class (6‑10)
        </label>
        <select
          value={classLevel}
          onChange={(e) => setClassLevel(e.target.value)}
          style={{ width: "100%", padding: 12, borderRadius: 12, border: "1px solid #e2e8f0", fontSize: 16, marginBottom: 16, background: "white" }}
        >
          <option value="">-- Select Class --</option>
          {[6, 7, 8, 9, 10].map(c => (
            <option key={c} value={c}>Class {c}</option>
          ))}
        </select>

        <Link
          to={classLevel ? `/exam-run/nstse?class=${classLevel}` : "#"}
          onClick={(e) => {
            if (!classLevel) {
              e.preventDefault();
              alert("Please select your class.");
            }
          }}
          style={{
            display: "inline-block",
            background: classLevel ? "linear-gradient(135deg, #fca311, #ff8c42)" : "#cbd5e1",
            color: "white",
            padding: "12px 24px",
            borderRadius: 30,
            fontWeight: 700,
            fontSize: 16,
            textDecoration: "none",
            boxShadow: classLevel ? "0 4px 12px rgba(252,163,17,0.4)" : "none",
            cursor: classLevel ? "pointer" : "not-allowed"
          }}
        >
          🚀 Start NSTSE Mock Test
        </Link>
      </div>

      {/* FAQ Section */}
      <div style={{ background: "#f8fafc", borderRadius: 16, padding: 20, marginTop: 30 }}>
        <h3 style={{ fontSize: 20, fontWeight: 700, color: "#1e293b", marginBottom: 12 }}>❓ Frequently Asked Questions</h3>
        <p style={{ fontWeight: 600, marginBottom: 4 }}>What is the NSTSE exam pattern?</p>
        <p style={{ color: "#475569", fontSize: 14, marginBottom: 12 }}>60 questions, 60 marks, 60 minutes. Includes Mathematics, Physics, Chemistry, Biology, and Critical Thinking.</p>
        <p style={{ fontWeight: 600, marginBottom: 4 }}>Is there negative marking in NSTSE?</p>
        <p style={{ color: "#475569", fontSize: 14, marginBottom: 12 }}>No negative marking is reported for NSTSE.</p>
        <p style={{ fontWeight: 600, marginBottom: 4 }}>Which classes should prepare for NSTSE?</p>
        <p style={{ color: "#475569", fontSize: 14 }}>We currently support Classes 6 to 10, which are the most relevant for science and mathematics preparation.</p>
      </div>

      <div style={{ textAlign: "center", marginTop: 24 }}>
        <Link to="/competitive-history" style={{ color: "#7c3aed", fontWeight: 700, textDecoration: "none" }}>
          📊 View My Past Exams
        </Link>
      </div>
    </div>
  );
};

export default NSTSELanding;